import { jsx as _jsx } from "react/jsx-runtime";
import { FileText } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { TemplatesListPage } from './routes/list-page.js';
const { Provider: TemplatesModulePermsProvider, usePerms: useTemplatesPerms } = createModulePerms({ canManage: false });
export { TemplatesModulePermsProvider };
function TemplatesPageRoute() {
    const { canManage } = useTemplatesPerms();
    return _jsx(TemplatesListPage, { canManage: canManage });
}
export const templatesModule = {
    id: 'templates',
    label: 'Templates',
    icon: FileText,
    // Nav visibility only: `template.read` is member-plus (a viewer does NOT
    // pass) and covers reading the list. Every mutation needs the separate
    // `template.manage` (supervisor-plus) — gated client-side via `canManage`.
    permission: 'template.read',
    workspace: 'support',
    order: 40,
    description: 'Reply templates with token interpolation at insert time.',
    routes: [{ path: '/', component: TemplatesPageRoute }],
};
export { TemplatesListPage } from './routes/list-page.js';
export { TemplateFormDialog } from './forms/create-dialog.js';
export { setTemplatesApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map